import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';

import Spinner from 'components/Spinner';
import SuspendSimoDeviceForm from './SuspendSimoDeviceForm';
import BaseModal from '../BaseModal';
import { suspendSimoDevice, findSimoDevice } from 'actions/simoDevices';
import { suspendSimoDeviceOptions } from 'api';

import styles from './styles.module.scss';

class SuspendSimoDeviceModal extends Component {
  state = {
    loading: false,
    suspensionOptions: [],
  };

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.loadSuspensionOptions();
    }
  }

  loadSuspensionOptions = () => {
    const { simoDevice } = this.props;
    suspendSimoDeviceOptions(simoDevice.id)
      .then((res) => {
        this.setState({
          suspensionOptions:
            res.data.actions.POST.suspension_status?.choices?.map((item) => [
              item.value,
              item.display_name,
            ]),
        });
      })
      .catch((e) => toast.error('Failed to load suspension reasons'))
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleSuspend = (values) => {
    const {
      simoDevice,
      suspendSimoDevice,
      findSimoDevice,
      loadDeviceSubs,
      closeModal,
    } = this.props;

    this.setState({ loading: true });
    return suspendSimoDevice(simoDevice.id, values)
      .then(() => findSimoDevice(simoDevice.id))
      .then(() => loadDeviceSubs())
      .then(() => {
        closeModal();
        toast.success('Device Suspended');
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { isOpen, closeModal } = this.props;
    const { loading, suspensionOptions } = this.state;

    return (
      <BaseModal
        isOpen={isOpen}
        title="Suspend Device"
        onClose={closeModal}
        className={styles.modal}
        confirmBtnText=""
        cancelBtnText=""
      >
        <SuspendSimoDeviceForm
          onSubmit={this.handleSuspend}
          suspensionOptions={suspensionOptions}
        />
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  suspendSimoDevice,
  findSimoDevice,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SuspendSimoDeviceModal);
